import React, { useState } from 'react';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import './SignupStep.css';
import DynamicForm from '../../components/dynamicForm';
import { signupStep2Schema } from '../../formData/signupStep2';
import { useNavigate } from 'react-router-dom'
export default function SignupStep2() {
    const navigate = useNavigate()
    const handleAction = (action, data) => {
        console.log('ACTION:', action, 'DATA:', data);
        if (action === 'next') {
            navigate('/signup/step-3', { })
        }
        if (action === 'back') {
            navigate('/', { })
        }
    };

    return (
        <div className="signup-page">
            <Header />
            <div className="signup-content">
                <Sidebar activeStep={2} />
                <main className="signup-main">
                    <div className='centered-alight-login-signup-comp'>
                        <div className='formTitle'>Company Information</div>
                        <p className="signup-desc">
                            Enter your company information below to set up your profile.
                        </p>
                            
                        <DynamicForm schema={signupStep2Schema} onAction={handleAction} />

                        <p className="login-prompt">
                            Already have an account? <a href="/login">Log In</a>
                        </p>
                    </div>
                </main>
            </div>
        </div>
    );
}
